import Handlebars from 'handlebars';

let spinnerContainerWidget = require('../../../views/widgets/spinnerContainerWidget/tmpl/spinnerContainerWidget.hbs');
Handlebars.registerPartial('spinnerContainerWidget', spinnerContainerWidget);

class SpinnerContainerWidgetService {
    create($element = $(document.body)) {
        let template = `
			{{> spinnerContainerWidget
				wg="spinnerContainerWidget"
				ns="SpinnerContainerWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		let spinnerContainerWidgetTemplate = Handlebars.template(precompiled);
		$element.append(spinnerContainerWidgetTemplate({}));
    }

    destroy($element = $(document.body)) {
        $element.find('[data-wg="SpinnerContainerWidget"]').remove();
    }
}

export let spinnerContainerWidgetService = new SpinnerContainerWidgetService();
